
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  TransferOverridePostRequest,
  TransferOverridePostResponse,
} from '../entities/transfer-override-configurations-v1/models';
import { axiosInstance } from "../axios-instance";

class TransferOverrideConfigurations {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queueConfigsToOverrideFileTransfer(
    input: TransferOverridePostRequest,
  ): Promise<AxiosResponse<TransferOverridePostResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<TransferOverridePostResponse>(`${this.baseUrl}/queueConfigs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default TransferOverrideConfigurations;
